var _path;
import * as React from "react";
function SvgMargarita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 0 4.0686355 2.0299978 6.5292006 5.1269531 7.8261719 C 5.4472547 11.625511 6.6408432 13.70419 11 13.966797 L 11 22 L 12 22 L 13 22 L 13 13.966797 C 17.359157 13.70419 18.552745 11.625511 18.873047 7.8261719 C 21.970002 6.5292006 24 4.0686355 24 0 C 19.113636 0.15886848 10.482798 0.03662556 0 0 z M 12 22 C 7.4967668 22 3.9999997 23.249461 4 24 C 9.0181747 24.03423 14.314143 24.228861 20 24 C 20 23.249461 16.503233 22 12 22 z "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMargarita);
export default __webpack_public_path__ + "static/media/Margarita.bdeb3516b5b009df3379c214600ea961.svg";
export { ForwardRef as ReactComponent };